import "./index.scss";
import Img from "../../assets/images/galleries_img.png";
import AnishKapoorImg from "../../assets/images/galleries/anish_kapoor.jpg";
import BanksyImg from "../../assets/images/galleries/banksy.jpg";
import CecilyBrownImg from "../../assets/images/galleries/cecily_brown.jpg";
import FrancoisMorelletImg from "../../assets/images/galleries/francois_morellet.jpg";
import JamesTurrellImg from "../../assets/images/galleries/james_turrell.jpg";
import JRImg from "../../assets/images/galleries/jr.jpg";
import JulianOpieImg from "../../assets/images/galleries/julian_opie.jpeg";
import KaraWalkerImg from "../../assets/images/galleries/kara_walker.jpg";
import ThomasRuffImg from "../../assets/images/galleries/thomas_ruff.jpg";
import YayoiKusamaImg from "../../assets/images/galleries/yayoi_kusama.jpg";
import ZaneleMuholiImg from "../../assets/images/galleries/zanele_muholi.jpg";

import React, { useEffect, useState } from "react";
import uid from "uid";

const Galleries = () => {
  const [img, setImg] = useState({ image: "", top: 0, left: 0 });
  const [positions, setPositions] = useState({ top: 0, left: 0 });

  const items = [
    [
      {
        id: 1,
        name: "Kara Walker",
        image: KaraWalkerImg,
      },
      {
        id: 2,
        name: "Yayoi Kusama",
        image: YayoiKusamaImg,
      },
    ],
    [
      {
        id: 3,
        name: "James Turrell",
        image: JamesTurrellImg,
      },
      {
        id: 4,
        name: "François Morellet",
        image: FrancoisMorelletImg,
      },
    ],
    [
      {
        id: 5,
        name: "Banksy",
        image: BanksyImg,
      },
      {
        id: 6,
        name: "JR",
        image: JRImg,
      },
      {
        id: 6,
        name: "Anish Kapoor",
        image: AnishKapoorImg,
      },
    ],
    [
      {
        id: 7,
        name: "Thomas Ruff",
        image: ThomasRuffImg,
      },
      {
        id: 8,
        name: "Julian Opie",
        image: JulianOpieImg,
      },
    ],
    [
      {
        id: 9,
        name: "Zanele Muholi",
        image: ZaneleMuholiImg,
      },
      {
        id: 10,
        name: "Cecily Brown",
        image: CecilyBrownImg,
      },
    ],
  ];

  const handleHover = (e, id, image) => {
    const galleriesEl = document.querySelector(".galleries");
    const imageEl = document.querySelector(".galleries__image");

    const rect = galleriesEl.getBoundingClientRect();
    const imageElHeight = imageEl.offsetHeight;
    const imageElWidth = imageEl.offsetWidth;

    const left = e.clientX - rect.left - imageElWidth / 2;
    const top = e.clientY - rect.top - imageElHeight / 2;

    setImg({ id, top, left, image });
  };

  const handleMouseOut = (e) => {
    setImg({ top: 0, left: 0, id: 0 });
  };

  return (
    <div className={`galleries-wrapper`}>
      <div className={`galleries`}>
        <div
          className={`galleries__image ${img.id && "galleries__image--active"}`}
          style={{
            left: img.left,
            top: img.top,
            backgroundImage: `url(${img.image})`,
          }}
        />
        <h3 className="galleries__title animate__animated animate__fadeInLeft">
          featured artists
        </h3>
        <div className="galleries__list">
          {items.map((item) => (
            <div key={uid()} className="galleries__row">
              {item
                .map((el) => (
                  <div
                    key={uid()}
                    onMouseOut={handleMouseOut}
                    onMouseMove={(e) => handleHover(e, el.id, el.image)}
                    className={`galleries__item ${
                      item.id === img.id && "galleries__item--active"
                    }`}
                  >
                    {el.name}
                  </div>
                ))
                .reduce((prev, curr) => [prev, " - ", curr])}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Galleries;
